"use strict";

exports.__esModule = true;
exports.default = find;
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _findIndex = _interopRequireDefault(require("./findIndex.js"));
var _findKey = _interopRequireDefault(require("./findKey.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return the first value which passes a truth test.
function find(obj, predicate, context) {
  var keyFinder = (0, _isArrayLike.default)(obj) ? _findIndex.default : _findKey.default;
  var key = keyFinder(obj, predicate, context);
  if (key !== void 0 && key !== -1) return obj[key];
}